import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { LayoutDashboard, FileText, Settings, X, ChevronLeft, ChevronRight, Menu, SlidersHorizontal, FolderKanban, LineChart } from 'lucide-react'
import { cn } from '@utils/cn'

const menuItems = [
  { icon: LayoutDashboard, label: 'Dashboard', path: '/' },
  { icon: FileText, label: 'Regras', path: '/regras' },
  { icon: SlidersHorizontal, label: 'Simulador', path: '/simulador' },
  { icon: FolderKanban, label: 'Cenários', path: '/cenarios' },
  { icon: LineChart, label: 'Análises', path: '/analises' },
  { icon: Settings, label: 'Configurações', path: '/configuracoes' },
]

export default function Sidebar() {
  const [isCollapsed, setIsCollapsed] = useState(false)
  const [isMobileOpen, setIsMobileOpen] = useState(false)

  return (
    <>
      {/* Mobile Overlay */}
      {isMobileOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setIsMobileOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={cn(
          'fixed top-0 left-0 h-full bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700 z-50 transition-all duration-300',
          isCollapsed ? 'w-20' : 'w-64',
          isMobileOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'
        )}
      >
        {/* Logo */}
        <div className="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700">
          {!isCollapsed && (
            <div className="flex items-center gap-3">
              <img src={`${import.meta.env.BASE_URL}/assets/icon.png`.replace('//', '/')} alt="BravoSim" className="w-10 h-10 flex-shrink-0" />
              <div className="flex flex-col">
                <h2 className="font-bold text-primary dark:text-primary-400 leading-tight">BravoSim</h2>
              </div>
            </div>
          )}
          
          {/* Collapse Button - Desktop */}
          <button
            onClick={() => setIsCollapsed(!isCollapsed)}
            className="hidden lg:block p-1.5 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            {isCollapsed ? (
              <ChevronRight className="h-5 w-5 text-gray-500" />
            ) : (
              <ChevronLeft className="h-5 w-5 text-gray-500" />
            )}
          </button>

          {/* Close Button - Mobile */}
          <button
            onClick={() => setIsMobileOpen(false)}
            className="lg:hidden p-1.5 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <X className="h-5 w-5 text-gray-500" />
          </button>
        </div>

        {/* Navigation */}
        <nav className="p-4 overflow-y-auto h-[calc(100vh-80px)] scrollbar-thin">
          <ul className="space-y-1">
            {menuItems.map((item) => (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    cn(
                      'flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200',
                      isActive
                        ? 'bg-primary text-white'
                        : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700',
                      isCollapsed && 'justify-center'
                    )
                  }
                  title={isCollapsed ? item.label : ''}
                >
                  <item.icon className="h-5 w-5 flex-shrink-0" />
                  {!isCollapsed && <span className="text-sm font-medium">{item.label}</span>}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </aside>

      {/* Mobile Menu Button */}
      <button
        onClick={() => setIsMobileOpen(true)}
        className={cn(
          'lg:hidden fixed top-4 right-4 z-50 p-3 bg-primary text-white rounded-full shadow-large transition-opacity',
          isMobileOpen && 'opacity-0 pointer-events-none'
        )}
        aria-label="Abrir menu"
      >
        <Menu className="h-6 w-6" />
      </button>
    </>
  )
}



